import React, { useState } from 'react';
import { DateRangePicker } from 'rsuite';
import {
  subDays,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek
} from 'date-fns';
import 'rsuite/DateRangePicker/styles/index.css';

export default function CommonDatePicker({ onChange, ...props }) {
  const today = new Date();
  const [value, setValue] = useState(null); 
  const handleChange = (newValue) => {
    setValue(newValue);
    onChange?.(newValue);
  };

  const customRanges = [
    {
      label: 'Yesterday',
      value: [subDays(today, 1), subDays(today, 1)]
    },
    {
      label: 'Last Week',
      value: [
        startOfWeek(subDays(today, 7), { weekStartsOn: 1 }),
        endOfWeek(subDays(today, 7), { weekStartsOn: 1 })
      ]
    },
    {
      label: 'This Month',
      value: [startOfMonth(today), endOfMonth(today)]
    },
    {
      label: 'Last Month',
      value: [
        startOfMonth(subDays(startOfMonth(today), 1)),
        endOfMonth(subDays(startOfMonth(today), 1))
      ]
    }
  ];

  return (
    <DateRangePicker
      value={value}
      onChange={handleChange}
      placeholder="Select Dates" // Changed from "Select Dates" to "Select Date"
      format="dd/MM/yyyy"
      character=" – "
      showOneCalendar
      ranges={customRanges}
      editable={false}
      className="dashdate"
      {...props}
    />
  );
}